import { ReactNode } from "react";

type ValidationHintTextProps = {
    name: string;
    hidden?: boolean;
    validationSummary: any;
    defaultContent?: ReactNode;
};

const ValidationHintText = (props: ValidationHintTextProps) => {
    const { name, validationSummary, defaultContent } = props;

    const errors = validationSummary[name];
    if (errors === undefined || errors === null || errors.length === 0) {
        return <>{defaultContent}</> ?? ' ';
    }

    if (errors.length === 1) {
        return errors[0];
    }

    let list = validationSummary[name] as string[];

    return (
        <ul>
            { list.map((v: string, index: number) => (
                <li key={`${name}-${index}`}>
                    {v}
                </li>
            ))}
        </ul>
    )
};

export default ValidationHintText;